// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Retheme'd against Untitled UI tokens, per
   assets/handoffs/design_handoff_quota_summary. Band structure (header rule
   → rows → rule → footer) comes from Card/Card.Header defaults; everything
   here is the row grid, bars, badges and footer definition list, which have
   no Untitled equivalent. */

.qs-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: none;
}

/* Card.Header's \`.headerText\` is \`flex:1;min-width:0\`, so it never forces a
   wrap on its own — it just keeps shrinking to make room for \`.qs-actions\`'
   two fixed-width buttons, squeezing the title/subtitle down to a sliver on
   narrow cards. \`flex-basis:100%\` forces the actions onto their own row
   instead of sharing one with the (now full-width) title. */
@media (max-width: 639px) {
  .qs-header .qs-actions {
    flex-basis: 100%;
  }
}

.qs-emphasis {
  font-weight: 500;
  color: var(--text-secondary);
}

/* Buttons: "Manage plan" (secondary) and "View plan usage" (tertiary brand —
   colours also satisfy the handoff's #7 explicit a/a:hover requirement). No
   primary/solid fill on this card by design (#2) — the bars carry brand
   colour instead. Both are <a> via react-router Link, so text-decoration
   needs to be set explicitly on hover too (global a:hover underlines). */
.qs-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 14px;
  border-radius: var(--radius-md);
  font-size: var(--text-sm-size);
  font-weight: 600;
  white-space: nowrap;
  text-decoration: none;
}

.qs-btn:hover {
  text-decoration: none;
}

.qs-btn--secondary {
  background: #ffffff;
  border: 1px solid var(--border-primary);
  box-shadow: var(--shadow-xs);
  color: var(--text-secondary);
}

.qs-btn--secondary:hover {
  background: var(--bg-secondary);
}

.qs-btn--tertiary {
  background: transparent;
  border: 1px solid transparent;
  color: var(--color-brand-700);
}

.qs-btn--tertiary:hover {
  background: var(--color-brand-50);
  color: var(--color-brand-800);
}

/* Rows */
.qs-rows {
  padding: 4px 0;
}

.qs-row {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: baseline;
  grid-column-gap: 16px;
  column-gap: 16px;
  grid-row-gap: 10px;
  row-gap: 10px;
  padding: 14px 24px;
  border-bottom: 1px solid var(--border-secondary);
}

.qs-rows .qs-row:last-child {
  border-bottom: 0;
}

.qs-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--text-sm-size);
  line-height: var(--text-sm-line);
  font-weight: 500;
  color: var(--text-primary);
}

.qs-per {
  font-size: var(--text-xs-size);
  font-weight: 400;
  color: var(--text-tertiary);
}

.qs-val {
  font-size: var(--text-sm-size);
  line-height: var(--text-sm-line);
  color: var(--text-tertiary);
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.qs-val strong {
  font-weight: 600;
  color: var(--text-primary);
}

.qs-val--zero strong {
  font-weight: 400;
  color: var(--text-quaternary);
}

.qs-val--muted {
  color: var(--text-tertiary);
}

/* Track spans both grid columns, on its own row under the label/value line. */
.qs-track {
  grid-column: 1 / -1;
  display: block;
  height: 6px;
  border-radius: var(--radius-full);
  background: var(--bg-tertiary);
  overflow: hidden;
}

.qs-fill {
  display: block;
  height: 100%;
  border-radius: var(--radius-full);
  background: var(--color-brand-600);
}

.qs-fill--warn {
  background: var(--color-warning-500);
}

.qs-fill--full {
  background: var(--color-warning-700);
}

/* "Limit reached" — filled, not soft, so it stands out from the "N left"
   warning badge. warning-700 (not -500/-600) is deliberate: those fail WCAG
   AA for white text at 12px. Type+class selector to outrank
   Badge.module.scss's colour classes regardless of CSS import order. */
span.qs-badge-filled {
  background: var(--color-warning-700);
  color: #ffffff;
  border-color: var(--color-warning-700);
  font-weight: 600;
}

/* Footer — untracked quotas, "Limit {y}" only, no bar. */
.qs-footer {
  border-top: 1px solid var(--border-secondary);
  padding: 4px 0;
}

.qs-footer-list {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-column-gap: 16px;
  column-gap: 16px;
  margin: 0;
}

.qs-footer-list dt,
.qs-footer-list dd {
  margin: 0;
  padding: 12px 0;
  font-size: var(--text-sm-size);
  line-height: var(--text-sm-line);
  border-bottom: 1px solid var(--border-secondary);
}

.qs-footer-list dt {
  padding-left: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-secondary);
}

.qs-footer-list dd {
  padding-right: 24px;
  text-align: right;
  color: var(--text-tertiary);
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.qs-footer-list dd strong {
  font-weight: 600;
  color: var(--text-primary);
}

.qs-footer-list dt:nth-last-of-type(1),
.qs-footer-list dd:nth-last-of-type(1) {
  border-bottom: 0;
}

/* Horizontal ("strip") mode — dashboard. Same data/thresholds as vertical
   (.qs-row above); .qs-track/.qs-fill are reused as-is here since
   grid-column:1/-1 is a no-op outside a grid container. */
.qs-strip {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  grid-gap: 24px;
  gap: 24px;
  padding: 20px 24px;
}

@media (max-width: 1199px) {
  .qs-strip {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 899px) {
  .qs-strip {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 559px) {
  .qs-strip {
    grid-template-columns: 1fr;
  }
}

.qs-strip-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

/* min-height is load-bearing: a label with a 24px badge otherwise resolves
   6px taller than a text-only one, pushing that item's value and bar below
   its neighbours' and staggering the bars across the row. */
.qs-strip-label {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-height: 24px;
  min-width: 0;
  font-size: var(--text-xs-size);
  line-height: 18px;
  font-weight: 500;
  color: var(--text-tertiary);
}

/* The number itself steps up to text-lg in strip mode; the " of {limit}"
   text stays at the base .qs-val size. */
.qs-val--lg strong {
  font-size: var(--text-lg-size);
  line-height: var(--text-lg-line);
}

.qs-strip-foot {
  margin: 0;
  padding: 12px 24px;
  border-top: 1px solid var(--border-secondary);
  font-size: var(--text-xs-size);
  line-height: 18px;
  color: var(--text-tertiary);
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.qs-strip-foot strong {
  font-weight: 600;
  color: var(--text-primary);
}
`, "",{"version":3,"sources":["webpack://./src/apps/admin/component/InfoWidgets/SubscriptionLimits/SubscriptionLimits.css"],"names":[],"mappings":"AAAA;;;;4BAI4B;;AAE5B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;;;;4DAI4D;AAC5D;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;;;yEAIyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA,SAAS;AACT;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,qBAAqB;EACrB,qBAAgB;EAAhB,gBAAgB;EAChB,kBAAa;EAAb,aAAa;EACb,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;EAC3B,6BAAkC;EAAlC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,8EAA8E;AAC9E;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;uEAGuE;AACvE;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,qBAAgB;EAAhB,gBAAgB;EAChB,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,8BAA8B;EAC9B,gCAAgC;EAChC,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;0DAE0D;AAC1D;EACE,aAAa;EACb,gDAAgD;EAChD,cAAS;EAAT,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;4DAE4D;AAC5D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;yCACyC;AACzC;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,6CAA6C;EAC7C,8BAA8B;EAC9B,iBAAiB;EACjB,2BAA2B;EAC3B,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B","sourcesContent":["/* Retheme'd against Untitled UI tokens, per\n   assets/handoffs/design_handoff_quota_summary. Band structure (header rule\n   → rows → rule → footer) comes from Card/Card.Header defaults; everything\n   here is the row grid, bars, badges and footer definition list, which have\n   no Untitled equivalent. */\n\n.qs-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: none;\n}\n\n/* Card.Header's `.headerText` is `flex:1;min-width:0`, so it never forces a\n   wrap on its own — it just keeps shrinking to make room for `.qs-actions`'\n   two fixed-width buttons, squeezing the title/subtitle down to a sliver on\n   narrow cards. `flex-basis:100%` forces the actions onto their own row\n   instead of sharing one with the (now full-width) title. */\n@media (max-width: 639px) {\n  .qs-header .qs-actions {\n    flex-basis: 100%;\n  }\n}\n\n.qs-emphasis {\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n/* Buttons: \"Manage plan\" (secondary) and \"View plan usage\" (tertiary brand —\n   colours also satisfy the handoff's #7 explicit a/a:hover requirement). No\n   primary/solid fill on this card by design (#2) — the bars carry brand\n   colour instead. Both are <a> via react-router Link, so text-decoration\n   needs to be set explicitly on hover too (global a:hover underlines). */\n.qs-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 14px;\n  border-radius: var(--radius-md);\n  font-size: var(--text-sm-size);\n  font-weight: 600;\n  white-space: nowrap;\n  text-decoration: none;\n}\n\n.qs-btn:hover {\n  text-decoration: none;\n}\n\n.qs-btn--secondary {\n  background: #ffffff;\n  border: 1px solid var(--border-primary);\n  box-shadow: var(--shadow-xs);\n  color: var(--text-secondary);\n}\n\n.qs-btn--secondary:hover {\n  background: var(--bg-secondary);\n}\n\n.qs-btn--tertiary {\n  background: transparent;\n  border: 1px solid transparent;\n  color: var(--color-brand-700);\n}\n\n.qs-btn--tertiary:hover {\n  background: var(--color-brand-50);\n  color: var(--color-brand-800);\n}\n\n/* Rows */\n.qs-rows {\n  padding: 4px 0;\n}\n\n.qs-row {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: baseline;\n  column-gap: 16px;\n  row-gap: 10px;\n  padding: 14px 24px;\n  border-bottom: 1px solid var(--border-secondary);\n}\n\n.qs-rows .qs-row:last-child {\n  border-bottom: 0;\n}\n\n.qs-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--text-sm-size);\n  line-height: var(--text-sm-line);\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.qs-per {\n  font-size: var(--text-xs-size);\n  font-weight: 400;\n  color: var(--text-tertiary);\n}\n\n.qs-val {\n  font-size: var(--text-sm-size);\n  line-height: var(--text-sm-line);\n  color: var(--text-tertiary);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.qs-val strong {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.qs-val--zero strong {\n  font-weight: 400;\n  color: var(--text-quaternary);\n}\n\n.qs-val--muted {\n  color: var(--text-tertiary);\n}\n\n/* Track spans both grid columns, on its own row under the label/value line. */\n.qs-track {\n  grid-column: 1 / -1;\n  display: block;\n  height: 6px;\n  border-radius: var(--radius-full);\n  background: var(--bg-tertiary);\n  overflow: hidden;\n}\n\n.qs-fill {\n  display: block;\n  height: 100%;\n  border-radius: var(--radius-full);\n  background: var(--color-brand-600);\n}\n\n.qs-fill--warn {\n  background: var(--color-warning-500);\n}\n\n.qs-fill--full {\n  background: var(--color-warning-700);\n}\n\n/* \"Limit reached\" — filled, not soft, so it stands out from the \"N left\"\n   warning badge. warning-700 (not -500/-600) is deliberate: those fail WCAG\n   AA for white text at 12px. Type+class selector to outrank\n   Badge.module.scss's colour classes regardless of CSS import order. */\nspan.qs-badge-filled {\n  background: var(--color-warning-700);\n  color: #ffffff;\n  border-color: var(--color-warning-700);\n  font-weight: 600;\n}\n\n/* Footer — untracked quotas, \"Limit {y}\" only, no bar. */\n.qs-footer {\n  border-top: 1px solid var(--border-secondary);\n  padding: 4px 0;\n}\n\n.qs-footer-list {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  column-gap: 16px;\n  margin: 0;\n}\n\n.qs-footer-list dt,\n.qs-footer-list dd {\n  margin: 0;\n  padding: 12px 0;\n  font-size: var(--text-sm-size);\n  line-height: var(--text-sm-line);\n  border-bottom: 1px solid var(--border-secondary);\n}\n\n.qs-footer-list dt {\n  padding-left: 24px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-secondary);\n}\n\n.qs-footer-list dd {\n  padding-right: 24px;\n  text-align: right;\n  color: var(--text-tertiary);\n  font-variant-numeric: tabular-nums;\n}\n\n.qs-footer-list dd strong {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.qs-footer-list dt:nth-last-of-type(1),\n.qs-footer-list dd:nth-last-of-type(1) {\n  border-bottom: 0;\n}\n\n/* Horizontal (\"strip\") mode — dashboard. Same data/thresholds as vertical\n   (.qs-row above); .qs-track/.qs-fill are reused as-is here since\n   grid-column:1/-1 is a no-op outside a grid container. */\n.qs-strip {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 24px;\n  padding: 20px 24px;\n}\n\n@media (max-width: 1199px) {\n  .qs-strip {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 899px) {\n  .qs-strip {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 559px) {\n  .qs-strip {\n    grid-template-columns: 1fr;\n  }\n}\n\n.qs-strip-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n/* min-height is load-bearing: a label with a 24px badge otherwise resolves\n   6px taller than a text-only one, pushing that item's value and bar below\n   its neighbours' and staggering the bars across the row. */\n.qs-strip-label {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  min-height: 24px;\n  min-width: 0;\n  font-size: var(--text-xs-size);\n  line-height: 18px;\n  font-weight: 500;\n  color: var(--text-tertiary);\n}\n\n/* The number itself steps up to text-lg in strip mode; the \" of {limit}\"\n   text stays at the base .qs-val size. */\n.qs-val--lg strong {\n  font-size: var(--text-lg-size);\n  line-height: var(--text-lg-line);\n}\n\n.qs-strip-foot {\n  margin: 0;\n  padding: 12px 24px;\n  border-top: 1px solid var(--border-secondary);\n  font-size: var(--text-xs-size);\n  line-height: 18px;\n  color: var(--text-tertiary);\n  font-variant-numeric: tabular-nums;\n}\n\n.qs-strip-foot strong {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
